import { Fragment } from "react";
import { usun_duplikaty } from "../../functions/grupy";
import { ikona } from "../../functions/ikony";
import { adres } from "../../functions/ulice";
import MieszkaniecDaneWoda from "../Mieszkancy/Woda/MieszkaniecDaneWoda";

const WodaMieszkaniec = props => {

    const { wybranyMieszkaniec, udzialyKontaAkt, grupy, ulice, lokale,  
        grupaUdzial, wybranyOdczyt, setWybranyOdczyt, mieszkaniec, grupy_g, rozliczenieWody } = props;

    const udzialyKontaAktU = udzialyKontaAkt?.filter( u => u?.id_user == wybranyMieszkaniec?.id_user)

    const udzialy = udzialyKontaAktU?.map( (udzial, i) => {

        const grupy_usera = grupy?.filter( g => g.id_user == wybranyMieszkaniec?.id_user && g.grupa_numer == udzial?.grupa_numer);

        const lokale_usera_temp = grupy_usera?.map( g => {
            return {
                id_lokal: g.id_lokal,
                id_user: g.id_user,
                grupa_numer: g.grupa_numer
            }
        });

        const lokale_usera = usun_duplikaty(lokale_usera_temp);

        const lokale_td = lokale_usera?.map( (lokal, i) => {
            return (
                <li key={i} className="left" >
                    {ikona(lokale?.filter( l => l.id === lokal.id_lokal )[0]?.rodzaj)} &nbsp; {`${adres(lokale?.filter( l => l.id === lokal.id_lokal )[0]?.ulica, ulice, lokal.id_lokal, lokale) }`} 
                </li>
            )
        });
        
        return (
            <div
                className="ramka woda-grupa"
                key={i}
            >
                <p className="woda-grupa-numer">
                    {`Grupa numer: ${udzial?.grupa_numer}`}
                </p>
                <ul 
                    className="woda-grupa-adres"
                    style={{"listStyle": "none"}}
                >
                    {lokale_td}
                </ul>
            </div>
        )
    })
    
    return (
        <div className="woda-odczyty">
            <div className="ramka woda-imie">
                {
                    wybranyMieszkaniec ? (
                        <p>{`${wybranyMieszkaniec?.imie_nazwisko} (${wybranyMieszkaniec?.id_user})`}</p>
                    ) : (
                        <p>Wybierz mieszkańca</p>
                    )
                }
            </div>
            {
                wybranyMieszkaniec && udzialy.length > 0 ? (
                    <div className="woda-grupy">
                        {udzialy}
                    </div>
                ) : (
                    <div className="woda-grupy">
                        <p className="ramka woda-brak">
                            Brak grup
                        </p>
                    </div>
                )
            }
            {
                wybranyMieszkaniec && (
                    <MieszkaniecDaneWoda
                        grupaUdzial={grupaUdzial}
                        wybranyOdczyt={wybranyOdczyt}
                        setWybranyOdczyt={setWybranyOdczyt}
                        mieszkaniec={mieszkaniec}
                        grupy_g={grupy_g}
                        rozliczenieWody={rozliczenieWody}
                    />
                )
            }

        </div>
    )
}

export default WodaMieszkaniec;